module.exports = __webpack_public_path__ + "static/media/test13_1.bd92c895.png";